import {defineStore} from 'pinia';
import { AxiosRequestConfig } from "axios";
import apiRequest from '@/util/api-request';

interface Notification {
  uuid: string;
  title: string;
  body: string;
  start_datetime: string;
  is_important: boolean;
  is_unread: boolean;
}

interface NotificationList {
  notification_base_url: string,
  notification_data: Notification[],
  only_unread_flag: boolean
}

const useNotificationListStore = defineStore('notificationListStore', {
  // state
  state: (): NotificationList => {
    return {
    notification_base_url: "/teacher/teacher/notification/",
      notification_data: null,
      only_unread_flag: false
    }
  },
  // getters
  getters: {
    notificationBaseUrl: (state) => {
        return state.notification_base_url
    },
    notificationData: (state) => {
      return state.notification_data
    },
    onlyUnreadFlag: (state) => {
      return state.only_unread_flag
    }
  },
  // actions
  actions: {
    async fetchNotificationList(is_unread: boolean) {
      const config: AxiosRequestConfig = {
        method: "get",
        url: "/teacher/api/notification/notification_list/",
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          is_unread: (is_unread) ? "True" : "False",
        }
      };
      const notifications = await apiRequest(config);
      this.notification_data = notifications.data;
    },
    saveOnlyUnreadFlag(payload) {
      this.only_unread_flag = payload
    }
  }
})

export {useNotificationListStore, Notification}